export const boxBorderRadius = "8px";

export default `
  --box-border-radius: ${boxBorderRadius};
`;
